import ListStore from '@/store/core/ListStore';
import { action, computed, override } from 'mobx';
import services from '@/api/services';
import { numGroup } from '@/utils/numbers';

interface TaxpayerStatisticsResponse {
  totalPayerCount: number;
  payerCount: number;
  totalReceiptCount: number;
  activeReceiptCount: number;
  cancelledReceiptCount: number;
  totalIncome: number;
  taxModeInfo: {
    accountType: string;
    tax: number;
  }[];
}

interface TaxpayerStatisticsInfo {
  totalPayerCount: number;
  payerCount: number;
  totalReceiptCount: number;
  activeReceiptCount: number;
  cancelledReceiptCount: number;
  totalIncome: string;
  taxModeInfo: {
    SC: string;
    MPC: string;
    CCSHI: string;
    IIT: string;
  };
}

const defaultFilters = {
  startDate: "",
  endDate: "",
};

export default class TaxpayerDetailsStore extends ListStore<TaxpayerStatisticsResponse> {
  @override
  filters = JSON.parse(JSON.stringify(defaultFilters));

  @computed get processedData() {
    if (!this.data) return;

    const info: TaxpayerStatisticsInfo = {
      totalPayerCount: this.data.totalPayerCount,
      payerCount: this.data.payerCount,
      totalReceiptCount: this.data.totalReceiptCount,
      activeReceiptCount: this.data.activeReceiptCount,
      cancelledReceiptCount: this.data.cancelledReceiptCount,
      totalIncome: numGroup(this.data.totalIncome),
      taxModeInfo: {
        SC: numGroup(
          this.data?.taxModeInfo?.find((e) => e.accountType === 'SC')?.tax || 0,
        ),
        MPC: numGroup(
          this.data?.taxModeInfo?.find((e) => e.accountType === 'MPC')?.tax ||
            0,
        ),
        CCSHI: numGroup(
          this.data?.taxModeInfo?.find((e) => e.accountType === 'CCSHI')?.tax ||
            0,
        ),
        IIT: numGroup(
          this.data?.taxModeInfo?.find((e) => e.accountType === 'IIT')?.tax ||
            0,
        ),
      },
    };

    return info;
  }

  @action.bound async fetch( ) {
    this.isFetching = true;
    try {
      const { data } = await services.platforms.getStatistics({
        ...this.notFalsyFilters,
        taxMode: 'PE',
      });
      this.data = data;
    } catch (e) {
      console.error(e);
    } finally {
      this.isFetching = false;
    }
  }
}
